import OmniAural from "omniaural"

OmniAural.addAction("setUserFromResponse", (response) => {
  const user = { ...response, ...response.user }
  OmniAural.state.user.set(user)
})

OmniAural.addAction("isUserMFARegistered", () => {
  const user = OmniAural.state.user?.value() || {}

  const isMFARegistered = user?.devices?.some((device) => device.second_factor)

  return isMFARegistered
})

OmniAural.addAction("isUserPFARegistered", () => {
  const user = OmniAural.state.user?.value() || {}

  const isPFARegistered = user?.devices?.some((device) => device.primary_factor)

  return isPFARegistered
})

OmniAural.addAction("getAllUserDevices", () => {
  const { devices = [], challenges = [], default_device_id } = OmniAural.state.user?.value() || {}

  devices.sort((a, b) => {
    // Sort by updated_at in descending order but if a device is registered, it should be at the top
    if (!a.deregistered_at && b.deregistered_at) {
      return -1
    }

    return new Date(b.updated_at) - new Date(a.updated_at)
  })

  // Find the default device and move it to the top
  const defaultDevice = devices.find((device) => device.device_id === default_device_id)
  if (defaultDevice) {
    devices.splice(devices.indexOf(defaultDevice), 1)
    devices.unshift(defaultDevice)
  }

  for (const device of devices) {
    device.challenges = []
    for (const challenge of challenges) {
      if (challenge.device_id === device.device_id) {
        device.challenges.push(challenge)
        device.challenges.sort((a, b) => new Date(b.responded_at) - new Date(a.responded_at))
      }
    }
  }

  return devices
})

OmniAural.addAction("showModal", ({ data, type, onConfirm }) => {
  OmniAural.state.modal.set({ show: true, data, type, onConfirm })
})

OmniAural.addAction("hideModal", () => {
  OmniAural.state.modal.set({ show: false, data: null, type: null, onConfirm: null })
})
